import { subscribeNotifications } from 'owa-calendar-events-store';
import { trace } from 'owa-trace';
import {
    getCalendarIdByFolderId,
    getFolderIdByCalendarID,
    calendarFolderIdNeedsUpdate,
    getAndUpdateActualFolderId,
} from 'owa-calendar-cache';

/**
 * Explicitly update folderIds and subscribe to notification. This is needed for group calendar.
 * VSO 50057 - Consolidate updateFolderIdsIfNeeded at a single place
 * https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/50057
 */
export default async function tryUpdateFolderIdsAndSubscribeToNotifications(
    folderIds: string[]
): Promise<string[]> {
    if (!folderIds) {
        return Promise.resolve([]);
    }
    let calendarIds = [];
    folderIds.forEach(folderId => {
        const calendarId = getCalendarIdByFolderId(folderId);
        // getCalendarIdByFolderId could return null for group calendar
        // Remove this null check once group calendar initialization is moved under /common
        // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/49088
        if (calendarId) {
            calendarIds.push(calendarId.id);
        }
    });

    await Promise.all(
        calendarIds
            .filter(calendarFolderIdNeedsUpdate)
            .map(getAndUpdateActualFolderId)
            .map(promise => promise.catch(handleError))
    );
    const updatedFolderIds = calendarIds
        .filter(id => !calendarFolderIdNeedsUpdate(id))
        .map(getFolderIdByCalendarID);

    updatedFolderIds.forEach(folderId => subscribeNotifications(folderId));
    return updatedFolderIds;
}

// catch and log any thrown errors for debugging, then resolve an empty promise so that Promise.all can still succeed
function handleError(error: Error): Promise<void> {
    trace.warn(`Failed to update folderId:\n${error}`);
    return Promise.resolve();
}
